<script>
  import formatarData from '~js/formatar-data';

  export default {
    props: ['relatorioAgrupado', 'relatorio'],
    methods: {
      retornaSaldoParcialSubRubrica(valorSubRubrica, lancamentos,index) {
        return lancamentos.slice(0, index + 1).reduce((total, lancamento) => {
          return total + lancamento.valorRateio;
        }, valorSubRubrica);
      },
      retornaSaldoParcialSubRubricaSubTotal(valorSubRubrica, lancamentos) {
        return lancamentos.reduce((total, lancamento) => {
          return total + lancamento.valorRateio;
        }, valorSubRubrica);
      }
    },
    computed: {
      saldoValor() {
        return this.relatorio.reduce((total, lancamento) => {
          return total + lancamento.valorRubrica;
          }, 0);
      },
      saldoTotalValor() {
        return this.relatorio.reduce((total, lancamento) => {
          return total + lancamento.totalValorRubrica;
        }, 0);
      },
      saldoGasto() {
        return this.relatorio.reduce((total, lancamento) => {
          return total + lancamento.valorGasto;
        }, 0);
      },
      saldoSaldoTotal() {
        return this.totalValorRubrica + this.saldoGasto;
      }
    }
  }
</script>

<template>
  <div>
    <table class="table relatorio table-bordered" v-for="(rubricas, index) in Object.entries(relatorioAgrupado)">
      <thead>
        <tr>
          <th colspan="5">{{rubricas[0]}}</th>
          <th class="text-center">Valor (R$)</th>
          <th class="text-center">Saldo (R$)</th>
        </tr>
      </thead>
      <tbody v-for="(subrubricas, index) in Object.entries(rubricas[1].groupBy('nomeSubRubrica'))">
        <tr style="background-color: #f5f5f6e0">
          <th colspan="5">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{subrubricas[0]}}</th>
          <th class="text-right" style="width: 150px;"></th>
          <th class="text-right" style="width: 150px;">{{ subrubricas[1][0].totalValorRubrica | formatarNumero }}</th>
        </tr>

        <tr v-for="(lancamento, index) in subrubricas[1]" v-if="subrubricas[1][0].idLancamento">
          <td>{{ lancamento.data | formatarData }}</td>
          <td>{{ lancamento.historico || '---' }}</td>
          <td>{{ lancamento.complemento || '---'}}</td>
          <td style="width: 110px;">{{ lancamento.documentoReceberPagar || '---'}}</td>
          <td :class="['text-center', lancamento.creditoDebito === 1 ? 'text-primary' : 'text-danger']" style="width: 30px;">{{ lancamento.creditoDebito === 1 ? 'C' : 'D' }}</td>
          <td :class="['text-right', lancamento.creditoDebito === 1 ? 'text-primary' : 'text-danger']" style="width: 150px;">{{ lancamento.valorRateio | formatarNumero }}</td>
          <td class="text-right" style="width: 150px;">{{ retornaSaldoParcialSubRubrica(subrubricas[1][0].totalValorRubrica, subrubricas[1],index) | formatarNumero }}</td>
        </tr>

        <tr style="background-color: #f5f5f6e0">
          <th colspan="5" class="text-center">SUB-TOTAL ....</th>
          <th class="text-right" style="width: 150px;"></th>
          <th class="text-right" style="width: 150px;">{{ retornaSaldoParcialSubRubricaSubTotal(subrubricas[1][0].totalValorRubrica, subrubricas[1]) | formatarNumero }}</th>
        </tr>
      </tbody>
    </table>
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/relatorio/componentes/LancamentoModelo3/PagamentosCompleto.vue